var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{staticClass:"pt-1",attrs:{"items":_vm.presets,"label":"Preset","background-color":"grey lighten-1","clearable":"","dense":"","solo":"","flat":"","item-text":"alias","item-value":"alias","return-object":"","hide-details":""},model:{value:(_vm.preset),callback:function ($$v) {_vm.preset=$$v},expression:"preset"}})
}
var staticRenderFns = []

export { render, staticRenderFns }